import * as env from "../config/env";
import axiosInstance from "../config/axios.config";


const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
};



const baseUrl = env.url;

export function getOrderDetails(barcode) {

    const config = {
        method: "GET",
        headers
    }
    return axiosInstance(`${baseUrl}/api/orders/${barcode}`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

export function sendOrderToReprint(data) {

    const config = {
        method: "POST",
        headers,
        data: data
    }
    return axiosInstance(`${baseUrl}/api/orders/reprint`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

const responseSuccessHandler = response => {
    return response.data
}


const responseErrorHandler = error => {

    return Promise.reject(error)
}
